import styled from "styled-components"
import { Slider as SliderPureReact, ButtonBack, ButtonNext } from "pure-react-carousel"
import CloudinaryImage from "components/cloudinary-image"
import { minWidth } from "utils"

export const Container = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 3rem;
  padding-bottom: 2rem;
  border-bottom: 0.3rem solid #eee;
  display: flex;
  flex-direction: column;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 4rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
    margin: 0 auto 6rem;
  `}
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 0.5rem solid #eee;
`

export const Title = styled.div`
  margin-bottom: 0.6rem;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  line-height: 3.2rem;
  color: #222;
`

export const Arrows = styled.div`
  display: flex;
  align-items: center;

  .carousel__back-button {
    display: flex;
    align-items: center;
  }
`

export const LeftArrow = styled(ButtonBack)`
  margin-right: 5rem;
  padding-top: 0.2rem;
  transform: rotate(180deg);
`

export const RightArrow = styled(ButtonNext)`
  margin-right: 1rem;
`

export const Slider = styled(SliderPureReact)`
  height: 30rem;
  padding-top: 2rem;
`

export const CardContainer = styled.a`
  width: 14.6rem;
  height: 23.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${minWidth.tablet`
    height: 27rem;
    width: 17.6rem;
  `}
`

export const EquipmentName = styled.p`
  margin: 1rem auto auto;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.8rem;
  line-height: 2.4rem;
  text-align: center;
  color: #222;
`

export const PriceReference = styled.p`
  margin: auto 0 0;
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.2rem;
  font-weight: 500;
  line-height: 2.2rem;
  text-align: center;
  text-transform: uppercase;
  text-decoration: underline;
  color: #222;
`

export const CardImage = styled(CloudinaryImage)`
  width: 100%;
  height: 14.6rem;

  ${minWidth.tablet`
    height: 17.6rem;
  `}
`
